import React from 'react';
import { motion } from 'framer-motion';
import { FilterItem } from './types';

interface SortableItemProps {
  id: string;
  item: FilterItem;
  isSelected: boolean;
  darkMode: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const SortableItem: React.FC<SortableItemProps> = ({
  id,
  item,
  isSelected,
  darkMode,
  onClick,
}) => {
  return (
    <motion.button
      layout
      onClick={onClick}
      className={`w-full px-2.5 py-1.5 text-left rounded-md transition-colors ${
        isSelected
          ? darkMode
            ? 'bg-blue-900/50 hover:bg-blue-900/70'
            : 'bg-blue-50 hover:bg-blue-100/80'
          : darkMode
            ? 'hover:bg-gray-600 focus:bg-gray-600'
            : 'hover:bg-gray-100 focus:bg-gray-100'
      }`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      <div className="flex items-center justify-between">
        <span className={`text-sm ${darkMode ? 'text-gray-100' : 'text-gray-900'}`}>{item.title}</span>
        <span className={`text-xs px-1.5 py-0.5 rounded-full ${
          item.type === 'note'
            ? darkMode
              ? 'bg-green-900 text-green-200'
              : 'bg-green-100 text-green-800'
            : item.type === 'card'
              ? darkMode
                ? 'bg-blue-900 text-blue-200'
                : 'bg-blue-100 text-blue-800'
              : darkMode
                ? 'bg-purple-900 text-purple-200'
                : 'bg-purple-100 text-purple-800'
        }`}>
          {item.type ? item.type.charAt(0).toUpperCase() + item.type.slice(1) : ''}
        </span>
      </div>
    </motion.button>
  );
};

export default SortableItem; 